import { useCallback, useState } from 'react';

import PhoneInputfield from 'react-phone-number-input/input';
import { isPossiblePhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import { E164Number } from 'libphonenumber-js';

import { useTranslationX } from 'i18n';
import { AuthResponse, useRequest } from 'api';
import { Button, Loader } from 'components/ui';
import { gtag } from 'utils';
import { Action } from './SignIn';

import styles from './PhoneInput.module.scss';

type Props = {
  dispatch: React.Dispatch<Action>;
};

const PhoneInput = ({ dispatch }: Props) => {
  const [phone, setPhone] = useState<E164Number>();
  const [busy, setBusy] = useState(false);

  const { tx } = useTranslationX('play.auth.phone');
  const request = useRequest({ autoclear: true });

  const submit = useCallback(
    (phone: E164Number) => {
      const phoneNumber = parsePhoneNumber(String(phone));

      if (phoneNumber) {
        setBusy(true);
        gtag('event', 'confirm_phone_cliked');

        request<AuthResponse>({
          url: '/userInteraction/requestValidation',
          method: 'POST',
          data: { dataType: 'phone', data: phoneNumber.number.toString() },
          onSuccess: payload => dispatch({ type: 'RESPONSE', payload }),
          onError: ({ response }) =>
            dispatch({
              type: 'ERROR',
              payload:
                response?.status === 400
                  ? 'play.auth.phone.error.invalid'
                  : 'play.auth.error.unknown',
            }),
          onComplete: () => setBusy(false),
        });
      }
    },
    [dispatch, request]
  );

  const renderContent = () => {
    if (busy) {
      return (
        <div className={styles.loader}>
          <Loader />
        </div>
      );
    }

    return (
      <>
        <PhoneInputfield
          className={styles.input}
          placeholder={tx('placeholder')}
          defaultCountry="US"
          smartCaret={false}
          value={phone}
          onChange={setPhone}
        />

        {isPossiblePhoneNumber(String(phone)) ? (
          <Button
            style={{ root: { height: '2.2rem', width: '100%' } }}
            onClick={() => (phone ? submit(phone) : null)}
          >
            {tx('button')}
          </Button>
        ) : null}
      </>
    );
  };

  return <div className={styles.phone}>{renderContent()}</div>;
};

export default PhoneInput;
